import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root',
// })
// export class SecureCookieService {

//   set(name: string, value: string, days?: number) {
//     let expires = '';
//     if (days) {
//       const date = new Date();
//       date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//       expires = '; expires=' + date.toUTCString();
//     }

//     const isSecure = window.location.protocol === 'https:';
//     const securityFlags = `; SameSite=Strict${isSecure ? '; Secure' : ''}`;

//     document.cookie = `${name}=${value || ''}${expires}; path=/${securityFlags}`;
//   }

//   get(name: string): string | null {
//     const nameEQ = name + '=';
//     const ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//       let c = ca[i];
//       while (c.charAt(0) === ' ') c = c.substring(1, c.length);
//       if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
//   }

//   delete(name: string) {
//     this.set(name, '', -1);
//   }

//   clearAll() {
//     const cookies = document.cookie.split(';');
//     for (let i = 0; i < cookies.length; i++) {
//       const cookie = cookies[i];
//       const eqPos = cookie.indexOf('=');
//       const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//       this.delete(name.trim());
//     }
//   }

//   hasCookies(): boolean {
//     return document.cookie.length > 0;
//   }
// }



// secure-cookie.service.ts

@Injectable({ providedIn: 'root' })
export class SecureCookieService {

  set(name: string, value: string, days?: number, path: string = '/') {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    const isSecure = window.location.protocol === 'https:';
    const secureFlag = isSecure ? '; Secure' : '';

    // ✅ SameSite=Strict har cookie pe force ho raha hai
    document.cookie = `${name}=${value || ''}${expires}; path=${path}; SameSite=Strict${secureFlag}`;
  }

  get(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.startsWith(nameEQ)) return c.substring(nameEQ.length);
    }
    return null;
  }

  // ✅ Fix: path parameter add kiya
  delete(name: string, path: string = '/') {
    const isSecure = window.location.protocol === 'https:';
    const secureFlag = isSecure ? '; Secure' : '';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=Strict${secureFlag}`;
  }

  clearAll() {
    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      this.delete(name); // path='/' default
    });
  }

  hasCookies(): boolean {
    return document.cookie.length > 0;
  }
}